import React, { useState } from 'react';
import styles from './ProductList.module.css';
import CloseBtn from '../../elemets/CloseBtn/CloseBtn';

export default function ProductList({
  products,
  unitBasket,
  ingredientObject,
  setShowProducsList,
}) {
  //   console.log('products === ', products);
  //   console.log('unitBasket === ', unitBasket);
  //   console.log('ingredientObject === ', ingredientObject);
  //   console.log('setShowProducsList === ', setShowProducsList);

  const [searchProductsArray, setSearchProductsArray] = useState([]);
  const [search, setSearch] = useState('');

  const changeProductsActive = (object, item, handleClick) => {
    object.textBasketProductNameDefault = item.productText;
    handleClick(false);
  };

  const renderProductsList = (products) => {
    if (products.length) {
      products.sort((a, b) => {
        const nameA = a.productText.toUpperCase();
        const nameB = b.productText.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });
      return products.map((item) => {
        return (
          <div
            onClick={() => changeProductsActive(ingredientObject, item, setShowProducsList)}
            key={item.id}
            className={
              item.productText === ingredientObject.textBasketProductNameDefault
                ? styles.productsList_text + ' ' + styles.productsList_text_active
                : styles.productsList_text
            }>
            {item.productText}
          </div>
        );
      });
    } else {
      return <div className={styles.productsList_text}>Пусто:)</div>;
    }
  };
  const searchProduct = (products, inputValue) => {
    setSearch(inputValue);

    const result = [];

    products.forEach((item) => {
      if (item.productText.toLowerCase().search(inputValue.toLowerCase()) != -1) {
        result.push(item);
      }
    });
    setSearchProductsArray(result);
  };
  return (
    <div className={styles.productsList_wrapper}>
      <div className={styles.productsList_top}>
        <div className={'fg_1'}>
          <input
            type="text"
            className={styles.input_search}
            placeholder="Пошук"
            defaultValue={search}
            onChange={(e) => searchProduct(products, e.target.value.trimStart())}
          />
        </div>
        <CloseBtn handleClick={setShowProducsList} />
      </div>
      {renderProductsList(search ? searchProductsArray : products)}
    </div>
  );
}
